import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, signal } from '@angular/core'
import { CamaraCapturaComponent } from './camara-captura'
import { VisorImagenComponent } from './visor-imagen'
import type { FotoProducto } from '../../application/sesion-captura'

/** Fila de captura para un angulo preestablecido. */
@Component({
  selector: 'app-fila-preset',
  standalone: true,
  imports: [CamaraCapturaComponent, VisorImagenComponent],
  templateUrl: './fila-preset.html',
})
export class FilaPresetComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) etiqueta!: string
  @Input() foto?: FotoProducto
  @Output() capturar = new EventEmitter<Blob>()
  @Output() eliminar = new EventEmitter<string>()

  readonly mostrarCamara = signal(false)
  readonly url = signal<string | undefined>(undefined)
  private urlActual?: string
  /** Ver en grande la foto ya tomada — pedido desde la feria, 2026-09-06. */
  readonly verAmpliada = signal(false)

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['foto']) return
    if (this.urlActual) URL.revokeObjectURL(this.urlActual)
    // Sin foto, o blob vacio (ya sincronizada y limpiada localmente >72h,
    // ver limpiarBlobsSincronizadosAntiguos en db.ts): mostramos el placeholder
    // de la camara en vez de un icono de imagen rota.
    if (!this.foto || this.foto.blob.size === 0) {
      this.urlActual = undefined
      this.url.set(undefined)
      return
    }
    this.urlActual = URL.createObjectURL(this.foto.blob)
    this.url.set(this.urlActual)
  }

  ngOnDestroy(): void {
    if (this.urlActual) URL.revokeObjectURL(this.urlActual)
  }

  alCapturar(blob: Blob): void {
    this.capturar.emit(blob)
    this.mostrarCamara.set(false)
  }

  abrirAmpliada(): void {
    if (this.url()) this.verAmpliada.set(true)
  }

  cerrarAmpliada(): void {
    this.verAmpliada.set(false)
  }
}
